import React, { useState } from 'react';
import { toast } from 'sonner';

import { useTheme } from '@/app/ThemeContext';
import { Input, Type } from '@/components/form/Input';
import { Modal } from '@/components/Modal';
import { useCreateIntegration } from '@/features/integrations/api';
import { Integration } from '@/types';

interface HackerOneSetupModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function HackerOneSetupModal({
  isOpen,
  onClose,
}: HackerOneSetupModalProps) {
  const { currentTheme } = useTheme();
  const [apiIdentifier, setApiIdentifier] = useState('');
  const [apiToken, setApiToken] = useState('');
  const { mutateAsync: createIntegration, status } = useCreateIntegration();

  const handleConnect = async () => {
    if (!apiIdentifier || !apiToken) {
      toast.error('Please fill in all required fields');
      return;
    }

    try {
      await createIntegration({
        integrationId: Integration.hackerone,
        name: 'HackerOne',
        credentials: {
          username: 'hackerone',
          api_identifier: apiIdentifier,
          api_token: apiToken,
        },
      });
      toast.success('HackerOne integration connected successfully');
      setApiIdentifier('');
      setApiToken('');
      onClose();
    } catch {
      // Error is handled by the mutation's defaultErrorMessage
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      size="xl"
      title={
        <div className="flex w-full flex-row items-center justify-between">
          <p>HackerOne Setup</p>
          <img
            src={`/icons/${currentTheme}/hackerone.svg`}
            alt="HackerOne"
            className="size-6"
          />
        </div>
      }
      footer={{
        text: 'Connect',
        onClick: handleConnect,
        disabled: status === 'pending' || !apiIdentifier || !apiToken,
        className: 'px-6',
        startIcon: undefined,
      }}
    >
      <div className="space-y-6">
        <Input
          label="API Identifier"
          name="api_identifier"
          value={apiIdentifier}
          onChange={e => setApiIdentifier(e.target.value)}
          placeholder="Enter your API identifier"
          required
        />
        <Input
          label="API Token"
          name="api_token"
          type={Type.PASSWORD}
          value={apiToken}
          onChange={e => setApiToken(e.target.value)}
          placeholder="Enter your API token"
          required
        />
      </div>
    </Modal>
  );
}
